import recallServices from '../../../services/notisphere/recall'
import recallSupplierServices from '../../../services/supplier/supplier-recall'
import recallProviderServices from '../../../services/provider/recall'
import RecallDetails from './RecallDetails'
import ChangeHistory from './ChangeHistory'
import WorkflowActions from '../../share/WorkflowActions'
import { COMMUNICATION_TYPE, USER_TYPE, PROVIDER_EVENTLISTING_STATUS } from '../../../misc/commons'
import _ from 'lodash'

export default {
    props: {
        id: { type: String, default: null },
        recallSiteId: { type: Number, default: null },
        switchSiteList: { type: Array, default: null },
        orgId: {type: Number, default: null },
    },
    components: {
        RecallDetails,
        ChangeHistory,
        WorkflowActions,
    },
    data() {
        return {
            item: null,
            provider_eventlisting_status: _.cloneDeep(PROVIDER_EVENTLISTING_STATUS),
            communicationType: null,
            disabledDelegate: false,
            providerCommunicationId: null,
            completedRecall: null,
            tabDetails: true,
            tabHistory: false,
            tabWorkflow: false,
            currentSite: null,
            title: '',
            switchSites: [],
            switchSitesTotal: 0,
            header: [
                {
                    label: 'Complete',
                    name: 'status_provider',
                    sort: true,
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-center',
                    column_classes: 'customalign-2ercent',
                    row_classes: 'customalign-2percent wordbreakall',
                },
                {
                    label: 'Recall ID',
                    name: 'communicationUID',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall',
                },
                {
                    label: 'Name',
                    name: 'name',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall table-text-ellipsis',
                },
                {
                    label: '# of Sites',
                    name: 'recall_sites',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Provider Name',
                    name: 'providerName',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Source',
                    name: 'isProviderCreated',
                    sort: true,
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-5percent',
                    row_classes: 'customalign-5percent wordbreakall',
                },
                {
                    label: 'Status',
                    name: 'status',
                    sort: true,
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-center',
                    column_classes: 'customalign-5percent',
                    row_classes: 'customalign-5percent wordbreakall',
                },
                {
                    label: '',
                    name: 'action',
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-center',
                },
            ],
        }
    },
    created() {
        this.communicationType = COMMUNICATION_TYPE.RECALL
        if (this.switchSiteList) {
            this.currentSite = this.switchSiteList.find(
                (site) => site.providerRecallSiteId == this.recallSiteId
            )
        }
        this.getRecallById()
        if (localStorage.getItem('typeFilterVal') == USER_TYPE.SUPP) {
            this.getSupplierCommunicationSummaryById()
        } else if (localStorage.getItem('typeFilterVal') == USER_TYPE.PROV) {
            this.getProviderCommunicationIdById()
        }
    },
    methods: {
        getRecallById() {
            recallServices.getRecallById(this.id).then((resp) => {
                if (resp.error) {
                    this.$router.push({ name: 'noti_Recall' })
                } else {
                    this.item = resp.data.d
                }
            })
        },
        deleteRecall() {
            this._showConfirm(
                'Are you sure you want to delete the recall, this cannot be undone?',
                { title: 'Delete Recall', variant: 'danger' }
            ).then((confirm) => {
                if (confirm) {
                    recallServices
                        .deleteRecall(this.id, this.item.supplier_id)
                        .then((resp) => {
                            if (!resp.error) {
                                this.$router.push({ name: 'noti_Recall' })
                                this._showToast('Recall Deleted!')
                            }
                        })
                }
            })
        },
        onReLoadCommunicationData() {
            if (localStorage.getItem('typeFilterVal') == USER_TYPE.SUPP) {
                this.getSupplierCommunicationSummaryById()
            } else if (localStorage.getItem('typeFilterVal') == USER_TYPE.PROV) {
                this.getProviderCommunicationIdById()
            }
        },
        getSupplierCommunicationSummaryById() {
            recallSupplierServices
                .getCommunicationSummaryById(this.id)
                .then((resp) => {
                    if (resp.error) {
                        this.$router.push({ name: 'noti_Recall' })
                    } else {
                        if (this.item.status == 'CLOSED') {
                            this.disabledDelegate = true
                            this.completedRecall = true
                        } else {
                            this.disabledDelegate = false
                        }
                    }
                })
        },
        getProviderCommunicationIdById() {
            recallProviderServices
                .getProviderCommunicationId(this.id, this.recallSiteId)
                .then((resp) => {
                    if (resp.error) {
                        this.$router.push({ name: 'noti_Recall' })
                    } else {
                        this.providerCommunicationId = resp.data.d
                    }
                })
        },
        viewRecall(item) {
            this.switchSites = this.switchSiteList
            this.switchSitesTotal = this.switchSiteList.length
            this.title = { type: 'Recall' }
            this.$root.$emit('bv::show::modal', 'modal-xl-switch', 'RECALL')
        },
        viewChildRecall(item) {
            this.$router.push({
                name: 'noti_ProvidersRecallView',
                params: {
                    id: item.id,
                    recallSiteId: item.providerRecallSiteId,
                    switchSiteList: this.switchSiteList,
                    orgId: item.providerOrgId
                },
            })
        },
    },
}
